/**
 * The price of a single selected seat for a passenger type, falling back to the untyped unit price then 0.
 * Shared so the summary seat row and the payable total always read the same number.
 */
export function getSeatSelectionPrice(
  seat: App.FlightsSeatsItem,
  passengerType?: App.Checkout.FlightPassenger['type'],
): number {
  const typedPrice = passengerType ? seat.pricesByPassengerType?.[passengerType]?.totalAmount?.amount : undefined
  return typedPrice ?? seat.unitPrice?.totalAmount?.amount ?? 0
}

/**
 * Total price of the selected seats across every flight-seat key, priced by each traveller's passenger type.
 */
export function sumSeatSelectionPrices(
  seatSelectionsByKey: Record<string, Record<string, Record<string, App.FlightsSeatsItem>>>,
  passengers: Array<App.Checkout.FlightPassenger>,
): number {
  const passengerTypeById = new Map(passengers.map(passenger => [passenger.id, passenger.type]))
  let total = 0
  for (const segments of Object.values(seatSelectionsByKey)) {
    for (const travellerSeats of Object.values(segments)) {
      for (const [travellerId, seat] of Object.entries(travellerSeats)) {
        const amount = getSeatSelectionPrice(seat, passengerTypeById.get(travellerId))
        if (amount > 0) {
          total += amount
        }
      }
    }
  }
  return total
}
